"use client";

import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import { Skeleton } from "@/components/ui/skeleton";

const ListingMap = dynamic(() => import("./ListingMap"), { ssr: false });

type Props = {
  point: {
    x: number;
    y: number;
  };
  city: string;
};

const ListingMapContainer: React.FC<Props> = ({ point }) => {
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  return (
    <div className="h-full w-full">
      {mounted ? (
        <ListingMap x={point.x} y={point.y} className="min-h-full" />
      ) : (
        <Skeleton className="h-96 min-h-full w-full rounded-none" />
      )}
    </div>
  );
};

export default ListingMapContainer;
